import { FormDialog } from 'components/dialog/form'
import { SearchsGuideLineResult, useEditSearchsGuideLine } from 'interface/search/guideLine'
import { useSearchsGuideLineForm, SearchsGuideLineForm } from '../form'

type EditSearchsGuideLineDialogProps = {
  searchId: number
  guideLine: SearchsGuideLineResult
  onSubmit: (result: SearchsGuideLineResult) => void
  onClose: () => void
}
export const EditSearchsGuideLineDialog = ({
  searchId,
  guideLine,
  onSubmit,
  onClose
}: EditSearchsGuideLineDialogProps) => {
  const [postState, submit] = useEditSearchsGuideLine(searchId, guideLine.searchsGuideLineId, { onEditted: onSubmit })
  const form = useSearchsGuideLineForm({ searchId, data: guideLine, onSubmit: submit })
  return (
    <FormDialog
      open
      fullWidth
      maxWidth="md"
      title={guideLine.guideLineName ?? ''}
      isLoading={postState.posting}
      error={postState.error}
      body={<SearchsGuideLineForm {...form}/>}
      submitLabel="確定"
      isValid={form.formState.isValid}
      onSubmit={form.submit}
      onClose={onClose}
    />
  )
}
